import React, { useEffect, useRef, useState } from 'react'
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import axios from 'axios';
import baseURL from '../../../configs/api';
import Select from "react-select";
import { getCountries } from '../../../services/country';
import { merticsSystemOptions, preferredDateFormatOptions } from '../../../utils/generalSettingOption';
import { useTheme } from '../../../components/hooks/useTheme';
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import Cookies from 'js-cookie';
import useTenant from '../../../components/hooks/useTenant';

type Props = {
  companyName: string;
  setCompanyName: (value: string) => void;
  country: string;
  setCountry: (value: string) => void;
  smsSender: string;
  setSmsSender: (value: string) => void;
  timezone: string;
  setTimezone: (value: string) => void;
  language: string;
  setLanguage: (value: string) => void;
  supportedLanguagesOptions: any[];
  SupportedLanguages: any;
  setSupportedLanguages: (value: any) => void;
  supportedLanguagesArray: any[]
  setSupportedLanguagesArray: (value: any[]) => void;
  preferredDateFormat: string;
  setPreferredDateFormat: (value: string) => void;
  metricSystem: string;
  setMetricSystem: (value: string) => void;
  setPleaseWaitPopup: (value: boolean) => void;
  filePath: string;
  setFilePath: (value: string) => void;
  favIcon: string;
  setFavIcon: (value: string) => void;
  rentalAgreementIcon: string;
  setRentalAgreementIcon: (value: string) => void;
  disabled: boolean;
  processRunTime: string;
  setProcessRunTime: (value: string) => void;
  processRunFrequency: string;
  setrocessRunFrequency: (value: string) => void;
  timezoneOptions: any[];
}

const GeneralSettings = ({
  companyName,
  setCompanyName,
  country,
  setCountry,
  smsSender,
  setSmsSender,
  timezone,
  setTimezone,
  language,
  setLanguage,
  supportedLanguagesOptions,
  SupportedLanguages,
  setSupportedLanguages,
  supportedLanguagesArray,
  setSupportedLanguagesArray,
  preferredDateFormat,
  setPreferredDateFormat,
  metricSystem,
  setMetricSystem,
  setPleaseWaitPopup,
  filePath,
  favIcon,
  setFilePath,
  setFavIcon,
  rentalAgreementIcon,
  setRentalAgreementIcon,
  disabled,
  processRunTime,
  setProcessRunTime,
  processRunFrequency,
  setrocessRunFrequency,
  timezoneOptions
}: Props) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const [isGeneralSettings, setIsGeneralSetttings] = useState<boolean>(true);
  const [countryOptions, setCountryOptions] = useState<any[]>([]);


  useEffect(() => {
    getCountries(tenantId)
      .then(data => {
        setCountryOptions(
          data.map((item: any) => {
            return { value: item.id, label: item.countryName }
          })
        );
        handleTenantError(null);
      })
       .catch((error) => {       
        handleTenantError(error);
      });

       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);

      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          setFilePath(response.data);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });

    } else {
      setPleaseWaitPopup(false);
    }
  };

  const inputFavIconeRef = useRef<HTMLInputElement>(null);
  const onFavIconChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);

      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          setFavIcon(response?.data);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });

    } else {
      setPleaseWaitPopup(false);
    }
  };

  const inputRentalAgreementIconeRef = useRef<HTMLInputElement>(null);
  const onRentalAgreementIconChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);

      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          setRentalAgreementIcon(response?.data);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });

    } else {
      setPleaseWaitPopup(false);
    }
  };

  return (
    <div>
      <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
        onClick={() => setIsGeneralSetttings(!isGeneralSettings)}
      >
        {isGeneralSettings ? (
          <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
        ) : (
          <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
        )}{" "}
        <div className="w-full flex flex-row justify-between items-center">
          <div style={{ color: themeStyles.topBar.textColor }}>General Settings</div>
          <div
            className="w-1/2 text-[10px] font-normal text-end"
            style={{ color: themeStyles.topBar.textColor }}
          >
            General Settings for this Tenant
          </div>
        </div>
      </h5>
      <hr />

      {isGeneralSettings &&
        <div className="w-full px-2 pt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Company Name</label>
                <input
                  type="text"
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={companyName}
                  disabled={disabled}
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                />
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>SMS Sender</label>
                <input
                  type="text"
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={smsSender}
                  disabled={disabled}
                  onChange={(e) => setSmsSender(e.target.value)}
                  required
                />
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Language</label>
                <select
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={language}
                  disabled={disabled}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  <option value="English">English</option>
                </select>
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Preferred Date Format</label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                      borderRadius: '8px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                      "&: hover": {
                        borderColor: "#167AC3",
                      }

                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "12px",
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                    }),
                    option: (base, state) => {
                      const isSelected = state.isSelected;
                      const isFocused = state.isFocused;
                      const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                      const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                      const defaultTextColor = themeStyles.topBar.textColor || "#000";

                      return {
                        ...base,
                        backgroundColor: isSelected
                          ? selectedBg
                          : isFocused
                            ? hoverBg
                            : "transparent",
                        color: isSelected ? "#fff" : defaultTextColor,
                        fontWeight: 600,
                        ':active': {
                          backgroundColor: isSelected ? selectedBg : hoverBg,
                        },
                      };
                    },
                    input: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={disabled}
                  isLoading={false}
                  isClearable={false}
                  isRtl={false}
                  isSearchable={false}
                  name="preferredDateFormat"
                  value={preferredDateFormatOptions.find(
                    (item: any) => item.value === parseInt(preferredDateFormat)
                  )}
                  onChange={(preferredDateFormat: any) =>
                    setPreferredDateFormat(preferredDateFormat ? preferredDateFormat.value : "")
                  }
                  options={preferredDateFormatOptions}
                />
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  <span>Process Run Time{" "}</span>

                  <div className="group relative inline-block">
                    <HelpOutlineOutlinedIcon sx={{ fontSize: "16px", cursor: "pointer" }} />

                    <span className={"absolute z-10 w-[150px] text-[10px] bg-white text-gray-600 text-center py-[5px] rounded border border-gray-400 bottom-full left-1/2 -ml-[75px] invisible group-hover:visible"}>
                      <span
                        className="absolute top-full left-[51%] -ml-[8px] border-8 border-transparent border-t-white z-10"
                      />
                      <span
                        className="absolute top-full left-1/2 -ml-[8px] border-10 border-transparent border-t-gray-400"
                      />
                      Time of day when the system checks vehicles for maintenance needs.
                    </span>
                  </div>
                </label>
                <input
                  type="time"
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={processRunTime}
                  disabled={disabled}
                  onChange={(e) => setProcessRunTime(e.target.value)}
                  required
                />
              </div>

              <div className="w-full flex flex-col gap-4 pb-5">
                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Tenant Logo</label>
                  {!filePath ?
                    <label className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`} onClick={(e) => {
                      if (inputFileRef.current !== null) {
                        inputFileRef.current?.click();
                      }
                    }}>  Add Logo</label>
                    :
                    <label
                      className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`}
                      onClick={(e) => {
                        if (!disabled) {
                          setFilePath("");
                        }
                      }}
                    >
                      Delete
                    </label>
                  }
                </div>

                <div className="max-w-1/2 flex flex-row items-center gap-[5px]">
                  {filePath &&
                    <img
                      src={`${baseURL}commonFile/Get?name=${filePath}`}
                      width={200}
                      height={125}
                      alt="tenantLogo"
                    />
                  }
                </div>
                <input
                  type="file"
                  accept="image/*"
                  name="tenantLogo"
                  ref={inputFileRef}
                  disabled={disabled}
                  onChangeCapture={onFileChangeCapture}
                  style={{ display: "none" }}
                />
              </div>

              <div className="w-full flex flex-col gap-4 pb-5">
                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Rental Agreement Icon</label>
                  {!rentalAgreementIcon ?
                    <label
                      className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`}
                      onClick={() => {
                        if (inputRentalAgreementIconeRef.current !== null) {
                          inputRentalAgreementIconeRef.current.click();
                        }
                      }}
                    >
                      Add Logo
                    </label>
                    :
                    <label
                      className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`}
                      onClick={() => {
                        if (!disabled) {
                          setRentalAgreementIcon("");
                        }
                      }}
                    >
                      Delete
                    </label>
                  }
                </div>

                <div className="max-w-1/2 flex flex-row items-center gap-[5px]">
                  {rentalAgreementIcon &&
                    <img
                      src={`${baseURL}commonFile/Get?name=${rentalAgreementIcon}`}
                      width={200}
                      height={125}
                      alt="rentalAgeementIcon"
                    />
                  }
                </div>
                <input
                  type="file"
                  accept="image/*"
                  name="rentalAgeementIcon"
                  ref={inputRentalAgreementIconeRef}
                  disabled={disabled}
                  onChangeCapture={onRentalAgreementIconChangeCapture}
                  style={{ display: "none" }}
                />
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Country</label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                      borderRadius: '8px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                      "&: hover": {
                        borderColor: "#167AC3",
                      }

                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "12px",
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                    }),
                    option: (base, state) => {
                      const isSelected = state.isSelected;
                      const isFocused = state.isFocused;
                      const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                      const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                      const defaultTextColor = themeStyles.topBar.textColor || "#000";

                      return {
                        ...base,
                        backgroundColor: isSelected
                          ? selectedBg
                          : isFocused
                            ? hoverBg
                            : "transparent",
                        color: isSelected ? "#fff" : defaultTextColor,
                        fontWeight: 600,
                        ':active': {
                          backgroundColor: isSelected ? selectedBg : hoverBg,
                        },
                      };
                    },
                    input: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={disabled}
                  isLoading={false}
                  isClearable={false}
                  isRtl={false}
                  isSearchable={false}
                  name="country"
                  value={countryOptions.find(
                    (item: any) => item.value === parseInt(country)
                  )}
                  onChange={(country: any) =>
                    setCountry(country ? country.value : "")
                  }
                  options={countryOptions}
                />
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Timezone</label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                      borderRadius: '8px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                      "&: hover": {
                        borderColor: "#167AC3",
                      }

                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "12px",
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                    }),
                    option: (base, state) => {
                      const isSelected = state.isSelected;
                      const isFocused = state.isFocused;
                      const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                      const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                      const defaultTextColor = themeStyles.topBar.textColor || "#000";

                      return {
                        ...base,
                        backgroundColor: isSelected
                          ? selectedBg
                          : isFocused
                            ? hoverBg
                            : "transparent",
                        color: isSelected ? "#fff" : defaultTextColor,
                        fontWeight: 600,
                        ':active': {
                          backgroundColor: isSelected ? selectedBg : hoverBg,
                        },
                      };
                    },
                    input: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={disabled}
                  isLoading={false}
                  isClearable={false}
                  isRtl={false}
                  isSearchable={true}
                  name="timezone"
                  value={timezoneOptions.find(
                    (item: any) => item.value === parseInt(timezone)
                  )}
                  onChange={(timezone: any) =>
                    setTimezone(timezone ? timezone.value : "")
                  }
                  options={timezoneOptions}
                />
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Supported Languages</label>
                <Select
                  isMulti
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                      borderRadius: '8px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                      "&: hover": {
                        borderColor: "#167AC3",
                      }

                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "12px",
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                    }),
                    option: (base, state) => {
                      const isSelected = state.isSelected;
                      const isFocused = state.isFocused;
                      const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                      const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                      const defaultTextColor = themeStyles.topBar.textColor || "#000";

                      return {
                        ...base,
                        backgroundColor: isSelected
                          ? selectedBg
                          : isFocused
                            ? hoverBg
                            : "transparent",
                        color: isSelected ? "#fff" : defaultTextColor,
                        fontWeight: 600,
                        ':active': {
                          backgroundColor: isSelected ? selectedBg : hoverBg,
                        },
                      };
                    },
                    input: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={disabled}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={false}
                  name="SupportedLanguages"
                  value={SupportedLanguages}
                  onChange={(value) => setSupportedLanguages(value)}
                  options={supportedLanguagesOptions}
                />
              </div>

              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Metric System</label>
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                      borderRadius: '8px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                      "&: hover": {
                        borderColor: "#167AC3",
                      }

                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "12px",
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.textColor,
                    }),
                    option: (base, state) => {
                      const isSelected = state.isSelected;
                      const isFocused = state.isFocused;
                      const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                      const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                      const defaultTextColor = themeStyles.topBar.textColor || "#000";

                      return {
                        ...base,
                        backgroundColor: isSelected
                          ? selectedBg
                          : isFocused
                            ? hoverBg
                            : "transparent",
                        color: isSelected ? "#fff" : defaultTextColor,
                        fontWeight: 600,
                        ':active': {
                          backgroundColor: isSelected ? selectedBg : hoverBg,
                        },
                      };
                    },
                    input: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.topBar.textColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={disabled}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={false}
                  name="metricSystem"
                  value={merticsSystemOptions.find(
                    (item: any) => item.value === metricSystem
                  )}
                  onChange={(metricSystem: any) =>
                    setMetricSystem(metricSystem ? metricSystem.value : "")
                  }
                  options={merticsSystemOptions}
                />
              </div>

              <div className="w-full flex flex-col gap-4 pb-5">
                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                    <span>Process Run Frequency{" "}</span>

                    <div className="group relative inline-block">
                      <HelpOutlineOutlinedIcon sx={{ fontSize: "16px", cursor: "pointer" }} />

                      <span className={"absolute z-10 w-[150px] text-[10px] bg-white text-gray-600 text-center py-[5px] rounded border border-gray-400 bottom-full left-1/2 -ml-[75px] invisible group-hover:visible"}>
                        <span
                          className="absolute top-full left-[51%] -ml-[8px] border-8 border-transparent border-t-white z-10"
                        />
                        <span
                          className="absolute top-full left-1/2 -ml-[8px] border-10 border-transparent border-t-gray-400"
                        />
                        Defines how frequently the system runs to check if any vehicles need maintenance based on your vehicle maintenance rules.
                      </span>
                    </div>
                  </label>
                  <select
                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                    value={processRunFrequency}
                    disabled={disabled}
                    onChange={(e) => setrocessRunFrequency(e.target.value)}
                  >
                    <option value="1">Every Minute</option>
                    <option value="2">Every Hour</option>
                    <option value="3">Every Day</option>
                    <option value="4">Every Month</option>
                    <option value="5">Every Year</option>
                    <option value="6">Every Weekday</option>
                  </select>
                </div>
                <div>
                  <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fav Icon</label>
                  {!favIcon ?
                    <label
                      className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`}
                      onClick={() => {
                        if (inputFavIconeRef.current !== null) {
                          inputFavIconeRef.current.click();
                        }
                      }}
                    >
                      Add Logo
                    </label>
                    :
                    <label
                      className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`}
                      onClick={() => {
                        if (!disabled) {
                          setFavIcon("");
                        }
                      }}
                    >
                      Delete
                    </label>
                  }
                </div>

                <div className="max-w-1/2 flex flex-row items-center gap-[5px]">
                  {favIcon &&
                    <img
                      src={`${baseURL}commonFile/Get?name=${favIcon}`}
                      width={200}
                      height={125}
                      alt="favIcon"
                    />
                  }
                </div>
                <input
                  type="file"
                  accept="image/*"
                  name="favIcon"
                  ref={inputFavIconeRef}
                  disabled={disabled}
                  onChangeCapture={onFavIconChangeCapture}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default GeneralSettings